<template>
    <div>
        <v-list two-line dense class="mt-2">
            <v-list-group>
                <template v-slot:activator>
                    <v-list-tile-content class="pa-2">
                        <v-list-tile-title style="height: unset !important"
                            ><span>Notes</span><v-chip small disabled text-color="black">{{ items.length || 0 }}</v-chip></v-list-tile-title
                        >
                    </v-list-tile-content>
                    <v-spacer></v-spacer>
                    <bc-tooltip>
                        <template slot="activator">
                            <v-btn icon @click.stop="$refs.noteDialog.showNote()"><v-icon>add</v-icon></v-btn>
                        </template>
                        Add Comment
                    </bc-tooltip>
                </template>
                <v-divider></v-divider>
                <template v-for="(item, index) in items">
                    <v-list-tile :key="item.note_id" avatar ripple @click="expandOrCollapseSubtitle(index)">
                        <v-list-tile-avatar>
                            <img :src="item.photo_thumb" />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.created_by }} - {{ item.date_created }}</v-list-tile-title>
                            <!-- <v-list-tile-sub-title
                                ><small></small></v-list-tile-sub-title
                            > -->
                            <v-list-tile-sub-title :class="{ expanded: expandedIndexes.includes(index) }">{{ item.note }}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-btn v-if="item.editable == 1" icon @click.stop="$refs.noteDialog.showNote(item)"><v-icon>edit</v-icon></v-btn>
                            <!-- <v-list-tile-action-text>{{ item.date_created }}</v-list-tile-action-text> -->
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-divider v-if="index + 1 < items.length" :key="index"></v-divider>
                </template>
            </v-list-group>
        </v-list>
        <!-- <bc-list
            v-if="(items || []).length > 0"
            :perm="perm"
            :items="items"
            prepend-position="top"
            prepend-icon="comment"
            @invoke-method="$refs.noteDialog.showNote($event)"
        >
            <template slot-scope="data">
                <v-container py-3 pr-3 pl-1>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div>
                                <v-flex list-sub black--text>{{ data.item.created_by }}</v-flex>
                                <v-flex list-sub style="font-size: 12px !important"> {{ data.item.date_created }}</v-flex>
                            </div>
                            <div style="white-space: pre-line">{{ data.item.note | shrink_text(250) }}</div>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-divider :key="index" :inset="true"></v-divider>
                <v-list-tile avatar ripple>
                    <v-list-tile-avatar>
                        <img :src="item.avatar" />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">{{ item.headline }}</v-list-tile-sub-title>
                        <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-list-tile-action-text>{{ item.action }}</v-list-tile-action-text>
                    </v-list-tile-action>
                </v-list-tile>
            </template>
        </bc-list> -->
        <!-- <v-layout row class="my-0 pt-2" v-if="hasPerm(perm) && hasScope('create')">
            <v-flex xs2 pt-0 style="max-width: 40px">
                <v-icon class="mt-3 mb-auto" color="indigo">mode_comment</v-icon>
            </v-flex>
            <v-flex class="xs10 px-0 pt-2 pb-0">
                <v-form ref="entity_note" style="margin: 0px -4px">
                    <v-textarea
                        v-model="entity_note.note"
                        :placeholder="$t('lang.add_note')"
                        auto-grow
                        single-line
                        rows="1"
                        :rules="ifValid('entity_note.note')"
                        hide-details
                        full-width
                        outline
                        style="left: 5px; bottom: 8px; max-width: 95%"
                        :key="growText"
                        @keydown.enter.exact.prevent="entity_note.note ? modifyEntityNote('post', id) : null"
                    >
                        <template slot="append">
                            <bc-tooltip top>
                                <template slot="activator">
                                    <v-btn v-if="!!entity_note.note" icon @mouseup.left="modifyEntityNote('post', id)" style="top: -20px">
                                        <v-icon class="material-icons-outlined">add</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t("lang.add") }}
                            </bc-tooltip>
                        </template>
                    </v-textarea>
                </v-form>
            </v-flex>
        </v-layout> -->

        <bc-notes-dialog
            ref="noteDialog"
            :entity-object="entityObject"
            :api-url="apiUrl"
            :scope="scope"
            :state-property="stateProperty"
            :state-mutate="stateMutate"
        ></bc-notes-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import { mapActions } from "vuex";

export default {
    props: {
        entityObject: {
            // object name matching store
            type: String,
            required: true,
        },
        scope: {
            // scope from parent
            type: String,
            default: null,
        },
        apiUrl: {
            // url that `/notes/${notes_id}` appends to for modifying note
            type: String,
            required: true,
        },
        stateProperty: {
            type: String,
            required: true,
        },
        stateMutate: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        perm: {
            type: [String, Boolean],
            default: true,
        },
        id: {
            type: [String, Number],
            default: null,
        },
        sendObject: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            entity_note: {
                note: "",
            },
            current_obj: null,
            entity_note_dialog: false,
            growText: 0,
            expandedIndexes: [],
        };
    },
    computed: {
        ...mapState({
            rules_entity_note: (state) => state.validation.rules_entity_note,
        }),
        fetchObject() {
            // use entity_object to create store action
            return `fetch${_.upperFirst(_.camelCase(this.entityObject))}`;
        },
        saveObject() {
            // use entity_object to create store action
            return `save${_.upperFirst(_.camelCase(this.entityObject))}`;
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        hasScope() {
            return (scope) => {
                return !this.scope || this.scope.includes(`${scope}`) || !this.currObjField("note_id");
            };
        },
    },
    methods: {
        ...mapActions(["saveModuleNote"]),
        close() {
            this.entity_note_dialog = false;
            if (this.$refs.delete_entity_note) this.$refs.delete_entity_note.close();
            this.$store.commit("toggleModalLoader", false);
        },
        modifyEntityNote(method = null, id = null) {
            let body = {
                note: this.entity_note.note,
                note_id: id,
                module_id: this.$route.params.id,
            };
            this.saveModuleNote({ body: body }).then((data) => {
                console.log(data);
            });
            // if (method && this.entity_note.note) {
            //     this.$nextTick(() => {
            //         this.$store.commit("toggleModalLoader", true);
            //         this.$store
            //             .dispatch(this.sendObject, {
            //                 pk: "note_id",
            //                 id: id,
            //                 url: `${this.apiUrl}/notes/`,
            //                 method: method,
            //                 stateProperty: this.stateProperty,
            //                 dataProperty: "notes",
            //                 mutate: true,
            //                 body: method != "delete" ? this.entity_note : null,
            //             })
            //             .then((data) => {
            //                 if (data && data.code == "200") {
            //                     this.close();
            //                     this.entity_note.note = "";
            //                     this.growText++;
            //                 } else {
            //                     this.$store.commit("toggleModalLoader", false);
            //                 }
            //             });
            //     });
            // }
        },
        showNote(item = null) {
            this.current_obj = item;

            if (this.$refs.entity_note) item ? this.$refs.entity_note.resetValidation() : this.$refs.entity_note.reset();

            this.$nextTick(() => {
                this.assignObj(this.entity_note, item, this.rules_entity_note);
                this.entity_note_dialog = true;
                this.growText++;
            });
        },
        expandOrCollapseSubtitle(index) {
            if (this.expandedIndexes.includes(index)) {
                this.expandedIndexes.splice(this.expandedIndexes.indexOf(index), 1);
            } else {
                this.expandedIndexes.push(index);
            }
        },
    },
};
</script>
<style lang="css">
.v-list__group:before,
.v-list__group:after {
    height: 0px !important;
}

.v-list--two-line.v-list--dense .v-list__tile {
    height: auto !important;
    min-height: 60px !important;
}
.expanded {
    white-space: normal !important;
}
</style>
